import { Box, styled } from '@mui/material'

// Global UI
import { TypographyP } from '@/ui'

export const ContactInfoDiv = styled(Box)(({ theme }) => ({
  background: '#877F6C',
  padding: `${theme.typography.pxToRem(50)} 0`,
}))

export const SubDiv = styled(Box)(({ theme }) => ({
  padding: `${theme.typography.pxToRem(30)} 0`,
}))

export const IconBgDiv = styled(Box)(({ theme }) => ({
  background: '#FFF',
  width: theme.typography.pxToRem(64),
  height: theme.typography.pxToRem(64),
  padding: theme.typography.pxToRem(32),
  borderRadius: '50%',
  transition: 'all 3s ease',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',

  '&:hover': {
    transform: 'scale(1.2)',
  },

  '& .MuiSvgIcon-root': {
    color: '#BDB29C',
    width: '1.3em',
    height: '1.3em',
  },
}))

export const LabelTitle = styled(TypographyP)(({ theme }) => ({
  color: '#FFF',
  fontSize: theme.typography.pxToRem(16),
  fontWeight: 500,
  margin: 0,
  padding: 0,
  marginBlock: 0,
}))

export const LabelSubTitle = styled(TypographyP)(({ theme }) => ({
  color: '#000',
  fontWeight: 400,
  fontSize: theme.typography.pxToRem(16),
  margin: `${theme.typography.pxToRem(10)} 0 0 0`,
  padding: 0,
}))
